import { getFilterIndicator } from "../helpers";
import type { ComparisonType } from "../types";

import type { FilterStrategy } from "./types";

const COMP_SYMBOLS: Record<ComparisonType, string> = {
  eq: "=",
  gte: "≥",
  lte: "≤",
};

const MAX_INT = 2147483647;

export const dollarStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (ctx.parsedNumber === null) return;
    const dollarAmount = ctx.parsedNumber;
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(dollarAmount);
    const score = ctx.looksLikeDate ? 40 : 80;
    if (ctx.parsedNumberQuery?.comparison) {
      const cmp = ctx.parsedNumberQuery.comparison;
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: `__dollar_${cmp}__`,
        optionLabel: `${COMP_SYMBOLS[cmp]} ${formatted}`,
        type: filterType.type,
        comparison: cmp,
        numericValue: dollarAmount,
        score,
        indicator: getFilterIndicator(filterType, true),
      });
      return;
    }
    const comparisons: { comparison: ComparisonType; symbol: string }[] = [
      { comparison: "eq", symbol: "=" },
      { comparison: "gte", symbol: "≥" },
      { comparison: "lte", symbol: "≤" },
    ];
    for (const c of comparisons) {
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: `__dollar_${c.comparison}__`,
        optionLabel: `${c.symbol} ${formatted}`,
        type: filterType.type,
        comparison: c.comparison,
        numericValue: dollarAmount,
        score,
        indicator: getFilterIndicator(filterType, true),
      });
    }
  },
  isSelected(currentValue, _optionValue, comparison, numericValue) {
    if (
      Array.isArray(currentValue) &&
      currentValue.length === 2 &&
      comparison &&
      numericValue !== undefined
    ) {
      const [lower, upper] = currentValue as [number | null, number | null];
      const cents = Math.round(numericValue * 100);
      const isLowerUnbounded = lower == null || lower === 0;
      const isUpperUnbounded = upper == null || upper >= MAX_INT;
      if (comparison === "eq") {
        return lower === cents && upper === cents;
      }
      if (comparison === "gte") {
        return lower === cents && isUpperUnbounded;
      }
      if (comparison === "lte") {
        return isLowerUnbounded && upper === cents;
      }
    }
    return false;
  },
  toggle(result) {
    if (result.comparison && result.numericValue !== undefined) {
      const cents = Math.round(result.numericValue * 100);
      let dollarValue: [number, number];
      if (result.comparison === "eq") {
        dollarValue = [cents, cents];
      } else if (result.comparison === "gte") {
        dollarValue = [cents, MAX_INT];
      } else {
        dollarValue = [0, cents];
      }
      return { value: dollarValue };
    }
    return { value: result.optionValue };
  },
};
